<template>
  <v-container grid-list-xs>
    <v-layout mt-2 mx-0 row wrap id="students-list-heading-row">
      <v-flex v-for="(header, key) in builtHeaders" :key="key" :class="header.html">
        <s-header-tooltip v-if="iconBased(key)" :text="$t('students.headers.' + key)" alignment="center"/>
        <s-header-tooltip v-else :text="$t('students.headers.' + key)"/>
      </v-flex>
      <v-flex v-if="flagEnableStudentActionBtn" xs2 sm1>
      </v-flex>
    </v-layout>
    <v-container grid-list-xs py-0>
      <v-divider/>
      <div v-for="student in students" :key="student.id">
        <studenttablerow :student="student"
                         :headers="builtHeaders"
                         :is-top-level="topLevel"
                         :is-icon-based="iconBased"/>
        <v-divider/>
      </div>
    </v-container>
    <div :style="{ backgroundColor: noStudentsColor}" class="no-data"
         v-if="students.length === 0 && !loading">
      <span :style="{color: getTextColor(noStudentsColor)}">{{$t('no_data_found_students_table')}}</span>
    </div>
  </v-container>
</template>

<script>
  import Studenttablerow from './StudentTableRow.vue'
  import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
  import { GET_LIST_OF_STUDENTS, GET_STUDY_MODES_STUDENTS } from '../../store/action-types'
  import {
    SET_STUDENT_LIST_SCROLL_TOP
  } from '../../store/mutation-types'
  import Colors from '../../mixins/Colors'
  import SHeaderTooltip from '../intervention/studentProfileIntervention/SHeaderTooltip'
  import { HAS_FEATURE_FLAG } from '../../store/getter-types'

  export default {
    components: {
      SHeaderTooltip,
      Studenttablerow
    },
    name: 'studenttable',
    mixins: [Colors],
    data () {
      return {
        noStudentsColor: this.$vuetify.theme.info,
        topLevelHeaders: ['studentName', 'interventionCount', 'alertCount', 'latestEngagementRating', 'latestAverageEngagementRating'],
        iconBasedHeaders: ['interventionCount', 'alertCount', 'latestEngagementRating', 'latestAverageEngagementRating', 'attendancePercentage']
      }
    },
    created () {
      // refresh on initial load and if filters aren't applied
      if (this.students.length === 0 && !this.filtersApplied) {
        this.getFilters()
      }
    },
    methods: {
      refreshTableOnScroll () {  // Used by FilteredTable
        this.getStudents()
      },
      ...mapActions({
        getStudents: GET_LIST_OF_STUDENTS,
        getFilters: GET_STUDY_MODES_STUDENTS
      }),
      ...mapMutations({
        updateScrollTop: SET_STUDENT_LIST_SCROLL_TOP
      }),
      topLevel (type) {
        return this.topLevelHeaders.includes(type)
      },
      iconBased (type) {
        return this.iconBasedHeaders.includes(type)
      },
      checkFeatureFlags () {
        let keys = Object.keys(this.headers)
        if (!this.flagEnableAlertColumn) {
          keys.splice(keys.indexOf('alertCount'), 1)
        }
        if (!this.flagDisplayAverageEngagementRating) {
          keys.splice(keys.indexOf('latestAverageEngagementRating'), 1)
        }
        if (!this.flagEnableInterventionColumn) {
          keys.splice(keys.indexOf('interventionCount'), 1)
        }
        return keys
      }
    },
    computed: {
      ...mapState({
        students: state => state.students.students,
        loading: state => state.students.loading,
        scrollTop: state => state.students.scrollTop,
        filtersApplied: state => state.students.filtersApplied,
        headers: state => state.students.headers,
        moduleAlert: state => state.profile.module.alert,
        moduleStudent: state => state.profile.module.student,
        moduleInterExem: state => state.profile.module.interexem,
        functionMyStudents: state => state.students.functions.myStudents,
        functionMyStudent: state => state.students.functions.myStudents,
        optionEnableAlertColumn: state => state.students.options.enable.alertColumn,
        optionEnableAverageEngagement: state => state.students.options.enable.averageEngagement,
        optionEnableInterventionColumn: state => state.students.options.enable.interventionColumn,
        optionEnableStudentActionBtn: state => state.students.options.enable.studentActionBtn,
        elementCount: state => state.students.elementCount
      }),
      getAllHeaders () {
        let allHeaders = {}
        Object.keys(this.headers).forEach(el => {
          if (this.checkFeatureFlags().includes(el)) {
            allHeaders[el] = this.headers[el]
          }
        })
        return allHeaders
      },
      getTopLevelHeaders () {
        let topLevelHeaders = {}
        Object.keys(this.headers).forEach(el => {
          if (this.topLevel(el) && this.checkFeatureFlags().includes(el)) {
            topLevelHeaders[el] = this.headers[el]
          }
        })
        return topLevelHeaders
      },
      builtHeaders () {
        return this.$vuetify.breakpoint.xsOnly
          ? this.getTopLevelHeaders
          : this.getAllHeaders
      },
      ...mapGetters({
        hasFeatureFlag: HAS_FEATURE_FLAG
      }),
      flagEnableAlertColumn () {
        return this.hasFeatureFlag(this.moduleAlert + '.' + this.functionMyStudents + '.' + this.optionEnableAlertColumn)
      },
      flagDisplayAverageEngagementRating () {
        return this.hasFeatureFlag(this.moduleStudent + '.' + this.functionMyStudent + '.' + this.optionEnableAverageEngagement)
      },
      flagEnableInterventionColumn () {
        return this.hasFeatureFlag(this.moduleInterExem + '.' + this.functionMyStudents + '.' + this.optionEnableInterventionColumn)
      },
      flagEnableStudentActionBtn () {
        return this.hasFeatureFlag(this.moduleInterExem + '.' + this.functionMyStudents + '.' + this.optionEnableStudentActionBtn)
      }
    },
    watch: {
      students (value) {
        // Resets the scrolling position to 0 every time the students list resets. Prevents scrolling issues.
        // See ST4-416
        if (value && value.length === 0) {
          window.scrollTo(0, 0)
        }
      }
    }
  }
</script>

<style scoped>
  .overflown {
    overflow-x: hidden;
  }

  .align-self-center {
    align-self: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/student/StudentTable.vue